import ApiBase from '../ApiBase';

// Check out the Duality Portal "Ordering Models" Wiki for guidance.

class ModelOrder extends ApiBase {
    route = '/model-order';

    /**
     * @method updateOrder
     * @param {object} data
     * @return {Promise<*>}
     */
    updateOrder = (data) => {
        return this.patch(this.route + '/update-order', data);
    };
}

export default new ModelOrder();
